import React from 'react';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import clsx from 'clsx';

import withSettings from '../../../utils/withSettings';
import styles from '../styles';
import { translate } from '../../../i18n/I18nProvider';
import FilterByStatus from './FilterByStatus';

const OrdersTableHeader = ({ classes, settings }) => {
  return (
    <div
      className={classes.headerRoot}
      style={{ color: settings.colors.primary }}
    >
      <div className={classes.label}>
        <i className={clsx('fas fa-shopping-cart', classes.icon)}></i>
        <div className={classes.title}>{translate('MENU.ORDERS')}</div>
      </div>
      <FilterByStatus />
    </div>
  );
};

const mapStatesToProps = ({ loader, auth }) => {
  return {
    isLoading: loader.isSpinVisible,
    lang: auth.lang
  };
};

export default flowRight(
  withSettings,
  connect(mapStatesToProps),
  withStyles(styles)
)(OrdersTableHeader);
